import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  slideshowCardWrapper: {
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    maxWidth: 440,
    margin: 'auto',
    marginTop: /* eslint-disable-line local-rules/use-theme-tokens */ 20,
    [`@media(max-width: ${theme.breakpoints.md}px)`]: {
      maxWidth: 353,
      marginTop: /* eslint-disable-line local-rules/use-theme-tokens */ -55,
    },
  },

  skeletonTitle: {
    marginBottom: /* eslint-disable-line local-rules/use-theme-tokens */ 10,
    marginTop: /* eslint-disable-line local-rules/use-theme-tokens */ 60,
  },
  title: {
    paddingBottom: /* eslint-disable-line local-rules/use-theme-tokens */ 10,
  },
  skeletonText: {
    width: 440,
    [`@media(max-width: ${theme.breakpoints.md}px)`]: {
      width: 320,
    },
  },
  copy: {
    marginBottom: /* eslint-disable-line local-rules/use-theme-tokens */ 50,
    maxWidth: 440,
    [`@media(max-width: ${theme.breakpoints.md}px)`]: {
      maxWidth: 353,
    },
  },
  imageWrapper: {
    alignItems: 'center',
    justifyContent: 'center',
    margin: 'auto',
    marginTop: /* eslint-disable-line local-rules/use-theme-tokens */ 20,
    [`@media(max-width: ${theme.breakpoints.md}px)`]: {
      maxWidth: '100%',
    },
  },
  image: {
    paddingTop: /* eslint-disable-line local-rules/use-theme-tokens */ 180,
    paddingBottom: /* eslint-disable-line local-rules/use-theme-tokens */ 25,
    [`@media(max-width: ${theme.breakpoints.md}px)`]: {
      paddingTop: /* eslint-disable-line local-rules/use-theme-tokens */ 75,
      marginBottom: /* eslint-disable-line local-rules/use-theme-tokens */ 25,
      paddingBottom: 0,
    },
  },
  skeletonImage: {
    width: 320,
    height: 650,
  },
}));

export default useStyles;
